/**
 * the tables in the database
 */
export enum DatabaseTable {
  PRE_EMPLOYMENT_ASSESSMENTS = 'pre_employment_assessments',
  INTAKE_RESPONSES = 'intake_responses',
  EMPLOYMENT_READINESS_RESPONSES = 'employment_readiness_responses',
  SKILLS_RESPONSES = 'skills_responses',
  CAREER_READINESS_RESPONSES = 'career_readiness_responses',
  EXPERIENCE_RESPONSES = 'experience_responses',
  SWOT_REPORTS = 'swot_reports',
  ORGANIZATIONS = 'organizations',
}
